module.exports = __webpack_public_path__ + "img/11825374_L.832845cd.png";